var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import './KodanshaNavbar.scss';
import { ReactComponent as Search } from '../Assets/icons/search.svg';
import { Link, useHistory } from 'react-router-dom';
import { AccountInfoAtom, LoginStatusAtom, LogoutAtom } from '../../store/AccountStore';
import { useAtom, useAtomValue } from 'jotai';
import { LoginOverlayVisible } from '../../store/OverlayStore';
import { KodanshaCart } from '../KodanshaCart/KodanshaCart';
import { FetchCartAtom, ShowCartAtom } from '../../store/CartStore';
import KodanshaEmail from '../KodanshaUIKit/KodanshaEmail/KodanshaEmail';
import KodanshaUnderlinedText from '../KodanshaUIKit/KodanshaUnderlinedText/KodanshaUnderlinedText';
import { KRow } from '../KodanshaUIKit/KodanshaGrid/KodanshaGrid';
import KodanshaArrow from '../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import { ReactComponent as FullLogo } from 'KodanshaAssets/Logo.svg';
import { ReactComponent as SmallLogo } from '../KodanshaAssets/Kodansha_Logo_dark.svg';
import { capitalizeFirstLetter, clearBrowseData, getScrollbarWidth, hideScroll, showScroll, } from '../../utils/utils';
import { useWindowSize } from '../Hooks/useWindowSize';
import SeriesPoster from '../KodanshaUIKit/SeriesPoster/SeriesPoster';
import ProductPoster from '../KodanshaUIKit/ProductPoster/ProductPoster';
import { FetchSearchAtom, FetchSearchQueryAtom, SearchResultLoadingStatus, } from '../../store/SearchStore';
import useDebounce from '../Hooks/useDebounce';
import { ResendVerification } from '../KodanshaAuth/KodanshaLogin/KodanshaLogin';
import { useCounter } from '../Hooks/useCounter';
var InnerMenu = function () {
    var _a;
    var _b = __read(useAtom(LoginStatusAtom), 1), loginStatus = _b[0];
    var _c = __read(useAtom(AccountInfoAtom), 1), accountInfo = _c[0];
    var _d = __read(useAtom(LoginOverlayVisible), 2), setLoginOverlay = _d[1];
    var _e = __read(useAtom(LogoutAtom), 2), logout = _e[1];
    var _f = __read(useState(false), 2), sendActive = _f[0], setSendActive = _f[1];
    var _g = useCounter('verification_time'), startTimer = _g.startTimer, sentTime = _g.sentTime, status = _g.status;
    var history = useHistory();
    useEffect(function () {
        status === false && setSendActive(true);
    }, [status]);
    var onEmailResendClicked = function () {
        setSendActive(false);
        if (typeof status === 'boolean') {
            ResendVerification().then(function () {
                startTimer();
            }).catch(function (e) {
                console.log(e);
                setSendActive(true);
            });
        }
    };
    return _jsxs(React.Fragment, { children: [_jsxs("div", { className: 'account-wrapper', children: [loginStatus === "LoggedIn" ?
                        _jsxs(React.Fragment, { children: [_jsx("span", { className: 'username-text', style: { borderTop: accountInfo.verified === false && '2px solid #000000' }, children: accountInfo.email }), accountInfo.verified === false && _jsxs("div", { className: 'account-verify-message-inner-wrapper', children: [_jsx("span", { className: 'account-verify-message-text', children: "Your account has not been verified." }), _jsx(KodanshaArrow, { onClick: onEmailResendClicked, active: sendActive, text: typeof status !== 'boolean' ? 'EMAIL HAS BEEN SENT' : 'SEND VERIFICATION EMAIL', withArrow: false })] })] })
                        :
                            _jsx(KRow, { onClick: function () { return setLoginOverlay(true); }, className: 'sign-in-create-account', children: _jsx("span", { className: 'login-or-signup pt-2', children: "Log in or sign up" }) }), _jsxs(_Fragment, { children: [_jsx("div", { className: 'divider' }), _jsxs("div", { className: 'library-wrapper', children: [_jsx(Link, { onClick: showScroll, className: "library-text ".concat(loginStatus !== "LoggedIn" && 'library-text-not-logged-in'), to: '/library', children: "Library" }), _jsx("div", { className: 'divider-v' }), loginStatus === "LoggedIn" && _jsx(Link, { onClick: showScroll, className: "account-text ".concat(loginStatus !== "LoggedIn" && 'account-text-not-active'), to: '/account', children: "Account" })] }), _jsx("div", { className: 'divider-2' })] })] }), _jsxs("div", { className: 'menu', children: [_jsxs("div", { className: 'div-instead-of-ul', children: [_jsx("li", { children: _jsx(Link, { className: 'route', to: '/browse', children: "Browse" }) }), _jsx("div", { className: 'divider' }), _jsx("div", { className: 'subMenu', children: _jsxs("ul", { children: [_jsx("li", { children: _jsx(Link, { onClick: showScroll, className: 'route route-first', to: '/calendar', children: "Release Calendar" }) }), _jsx("li", { children: _jsx(Link, { onClick: showScroll, className: 'route route-first', to: '/browse?st=3&&is=false', children: "New Releases" }) }), _jsx("li", { children: _jsx(Link, { onClick: showScroll, className: 'route', to: '/browse?is=false&status=-1&p=0&s=0&st=sale', children: "On Sale" }) }), _jsx("div", { className: 'divider' })] }) }), _jsx(Link, { className: 'route', to: '/news', children: "News" })] }), ((_a = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.roles) === null || _a === void 0 ? void 0 : _a.includes('admin')) &&
                        _jsx(Link, { onClick: showScroll, className: 'route complete-menu-accounts-nav-dashboard', to: '/dashboard', children: "Dashboard" }), loginStatus === "LoggedIn" && _jsx("div", { className: 'logout-wrapper', children: _jsx("span", { className: 'logout-text', onClick: function () {
                                logout();
                                showScroll();
                            }, children: "Logout" }) })] })] });
};
var RecentSearchItem = function (_a) {
    var name = _a.name, setSearchValue = _a.setSearchValue;
    return _jsxs("div", { className: 'recent-search-item-wrapper', onClick: function () {
            setSearchValue(name);
        }, children: [_jsx(Search, { "aria-label": 'search icon', width: 25, height: 25 }), _jsx("span", { "aria-label": 'recent search' + name, className: 'recent-search-item-text', children: name })] });
};
var selectSearchItem = function (itemName) {
    // const isDuplicate = Object.values(localStorage).includes(itemName);
    // if (isDuplicate) {
    //     return;
    // }
    var searchHistory = JSON.parse(localStorage.getItem('SearchHistory') || '[]');
    var filteredHistory = searchHistory.filter(function (item) { return item !== itemName; });
    // Add the current item to the beginning of the filtered search history array
    filteredHistory.unshift(itemName);
    // Limit the search history array to 5 items
    var limitedHistory = filteredHistory.slice(0, 5);
    // Store the updated search history array in local storage
    localStorage.setItem('SearchHistory', JSON.stringify(limitedHistory));
    // localStorage.setItem('SearchHistory5', localStorage.getItem('SearchHistory4') || '');
    // localStorage.setItem('SearchHistory4', localStorage.getItem('SearchHistory3') || '');
    // localStorage.setItem('SearchHistory3', localStorage.getItem('SearchHistory2') || '');
    // localStorage.setItem('SearchHistory2', localStorage.getItem('SearchHistory1') || '');
    // localStorage.setItem('SearchHistory1', itemName);
};
var ClearSearch = function () {
    console.log('Clearing Search');
    localStorage.setItem('SearchHistory', '[]');
};
var RecentSearches = function (_a) {
    var setSearchValue = _a.setSearchValue, isSearchOpen = _a.isSearchOpen, width = _a.width;
    var _b = __read(useState(false), 2), clearedSearch = _b[1];
    var recentSearch = [];
    var itemNames = JSON.parse(localStorage.getItem('SearchHistory'));
    itemNames === null || itemNames === void 0 ? void 0 : itemNames.forEach(function (itemName) {
        if (itemName)
            recentSearch.push(itemName);
    });
    if (recentSearch.length === 0) {
        if (width > 1024 && !isSearchOpen) {
            return null;
        }
        return _jsx("div", { className: 'search-message-wrapper', children: _jsx("span", { "aria-label": 'No recent search', className: 'search-message-text', children: "No recent search" }) });
    }
    return _jsx(React.Fragment, { children: _jsxs("div", { className: 'recent-search-container', children: [recentSearch.length !== 0 && _jsxs("div", { className: 'clear-search-wrapper', children: [_jsx("span", { className: 'recent-search-text', "aria-label": 'Recent search', children: "Recent search" }), _jsx(KodanshaUnderlinedText, { text: 'Clear search', "aria-label": 'Clear search', onClick: function () {
                                ClearSearch();
                                clearedSearch(true);
                            } })] }), recentSearch.length !== 0 && _jsx("div", { className: 'recent-search-items-container', children: recentSearch.map(function (item, index) {
                        return _jsx(RecentSearchItem, { name: item, setSearchValue: setSearchValue }, index);
                    }) })] }) });
};
var SearchBar = function (_a) {
    var searchValue = _a.searchValue, setSearchValue = _a.setSearchValue, setIsSearchOpen = _a.setIsSearchOpen, IsEnterBlocked = _a.IsEnterBlocked, setIsFocusOnSearchInput = _a.setIsFocusOnSearchInput, goToSearchPage = _a.goToSearchPage;
    var width = useWindowSize().width;
    var emailRef = useRef(null);
    useEffect(function () {
        if (width > 1024) {
            emailRef.current.focus();
            setIsFocusOnSearchInput(true);
        }
        // return (): void => {
        // setIsFocusOnSearchInput(false);
        // };
    }, []);
    var onSubmit = function (e) {
        e.preventDefault();
        showScroll();
        goToSearchPage();
    };
    return _jsxs(_Fragment, { children: [width >= 1024 && _jsx("div", { "aria-label": 'search bar', onClick: function () {
                    setIsSearchOpen(false);
                }, className: 'navbar-backdrop-search' }), _jsxs("div", { className: 'menu-search-wrapper', children: [_jsx("span", { "aria-label": 'Search by title or creator', className: 'menu-search-text', children: "Search by title or creator" }), _jsxs("form", { className: 'menu-search-input-wrapper', children: [_jsx(KodanshaEmail, { value: searchValue, onEnterPushed: !IsEnterBlocked ? goToSearchPage : function () { return 2; }, ref: emailRef, ariaLabel: 'search for product or series', onSubmit: onSubmit, onChange: function (text) { return setSearchValue(text); }, onFocus: function () { return setIsFocusOnSearchInput(true); }, 
                                // onBlur={(): void => setIsFocusOnSearchInput(false)}
                                placeHolder: '' }), _jsx(Search, { "aria-label": 'search icon', width: 25, onClick: goToSearchPage })] })] })] });
};
var SearchResults = function (props) {
    var history = useHistory();
    var _a = __read(useAtom(SearchResultLoadingStatus), 1), searchLoading = _a[0];
    var _b = __read(useState(-1), 2), selectedIndex = _b[0], setSelectedIndex = _b[1];
    var searchWrapperRef = useRef(null);
    var listenerToRemove = useRef(null);
    var selectedIndexRef = useRef(-1);
    var firstRender = useRef(true);
    var slicedArray = props.items.slice(0, Math.min(props.items.length, 20));
    var scrollToItem = function (number) {
        var itemRef = document.getElementById('search-result-item-wrapper' + number.toString());
        itemRef === null || itemRef === void 0 ? void 0 : itemRef.scrollIntoView({ behavior: 'smooth' });
        itemRef === null || itemRef === void 0 ? void 0 : itemRef.focus();
    };
    useEffect(function () {
        selectedIndexRef.current = selectedIndex;
    }, [selectedIndex]);
    useEffect(function () {
        // if (slicedArray.length > 0 && firstRender.current === true) {
        //     firstRender.current = false;
        listenerToRemove.current = function handleKeyDown(event) {
            var _a, _b, _c, _d, _e;
            if (event.key === 'ArrowDown') {
                props.onEnterBlocked();
                setSelectedIndex(function (prevIndex) {
                    if (prevIndex >= slicedArray.length - 1) {
                        scrollToItem(slicedArray.length - 1);
                        return slicedArray.length - 1;
                    }
                    else {
                        scrollToItem(prevIndex + 1);
                        return prevIndex + 1;
                    }
                });
            }
            else if (event.key === 'ArrowUp') {
                setSelectedIndex(function (prevIndex) {
                    if (prevIndex <= 0) {
                        scrollToItem(0);
                        return 0;
                    }
                    else {
                        scrollToItem(prevIndex - 1);
                        return prevIndex - 1;
                    }
                });
            }
            else if (event.key === 'Enter') {
                // console.log('props.items', props.items, selectedIndex, selectedIndexRef.current);
                if (selectedIndexRef.current === -1) {
                    props.goToSearchPage();
                    // history.push('/search');
                }
                else {
                    selectSearchItem((_a = props.items[selectedIndexRef.current]) === null || _a === void 0 ? void 0 : _a.content.title);
                    history.push("/".concat((_b = props.items[selectedIndexRef.current]) === null || _b === void 0 ? void 0 : _b.type, "/") + ((_d = (_c = props.items[selectedIndexRef.current]) === null || _c === void 0 ? void 0 : _c.content.readableUrl) !== null && _d !== void 0 ? _d : (_e = props.items[selectedIndexRef.current]) === null || _e === void 0 ? void 0 : _e.content.id));
                }
            }
        };
        document.addEventListener('keydown', listenerToRemove.current);
        // }
        return function () {
            document.removeEventListener('keydown', listenerToRemove.current);
        };
    }, [slicedArray]);
    if (props.searchValue.length === 1) {
        return _jsx("div", { className: 'search-message-wrapper', children: _jsx("span", { "aria-label": 'Please enter more than one character', className: 'search-message-text', children: "Please enter more than one character" }) });
    }
    if (searchLoading === true) {
        return _jsx("div", { className: 'search-message-wrapper', children: _jsx("span", { "aria-label": 'loading search', className: 'search-message-text', children: "Loading ..." }) });
    }
    if (props.items.length == undefined || props.items.length == 0) {
        return _jsx("div", { className: 'search-message-wrapper', children: _jsx("span", { "aria-label": 'No search result', className: 'search-message-text', children: "No search result" }) });
    }
    return _jsx("div", { ref: searchWrapperRef, className: 'search-result-wrapper', children: slicedArray.map(function (item, index) {
            var _a, _b, _c;
            console.log('item', item);
            return _jsxs("div", { id: 'search-result-item-wrapper' + index.toString(), className: 'search-result-item-wrapper', style: { backgroundColor: selectedIndex === index && '#C6C6C6' }, onClick: function () {
                    var _a;
                    props.closeMenus();
                    showScroll();
                    selectSearchItem(item.content.title);
                    history.push("/".concat(item.type, "/") + ((_a = item.content.readableUrl) !== null && _a !== void 0 ? _a : item.content.id));
                }, children: [item.type === 'series' ? _jsx(SeriesPoster, { src: (_a = item.content.thumbnails[0]) === null || _a === void 0 ? void 0 : _a.url, ratio: 140, 
                        // color={getRandomColorByIndex(index)}
                        color: (_b = item.content.thumbnails[0]) === null || _b === void 0 ? void 0 : _b.color, alt: 'cover for ' + item.content.title }) :
                        _jsx(ProductPoster, { ratio: 140, src: (_c = item.content.thumbnails[0]) === null || _c === void 0 ? void 0 : _c.url, alt: 'cover for ' + item.content.title }), _jsxs("div", { className: 'search-result-info-wrapper', children: [_jsx("span", { "aria-label": "".concat(item.displayType, " ").concat(item.content.title), className: 'search-result-type', children: capitalizeFirstLetter(item.displayType) }), _jsx("span", { "aria-label": "".concat(item.displayType, " ").concat(item.content.title), className: 'search-result-name', children: capitalizeFirstLetter(item.content.title) })] })] }, index);
        }) });
};
function ShowInnerMenu(_a) {
    var isMenuOpen = _a.isMenuOpen, isSearchOpen = _a.isSearchOpen, setIsMenuOpen = _a.setIsMenuOpen, setIsSearchOpen = _a.setIsSearchOpen, setIsFocusOnSearchInput = _a.setIsFocusOnSearchInput, isFocusOnSearchInput = _a.isFocusOnSearchInput;
    var width = useWindowSize().width;
    var _b = __read(useAtom(FetchSearchQueryAtom), 2), searchValue = _b[0], setSearchValue = _b[1];
    var loginOverlay = useAtomValue(LoginOverlayVisible);
    var _c = __read(useState(''), 2), innerSearchValue = _c[0], setInnerSearchValue = _c[1];
    var _d = __read(useState(false), 2), IsEnterBlocked = _d[0], setIsEnterBlocked = _d[1];
    var _e = __read(useAtom(FetchSearchAtom), 2), searchArray = _e[0], fetchSearch = _e[1];
    var history = useHistory();
    var debouncedValue = useDebounce(searchValue, 200);
    useEffect(function () {
        if (!isSearchOpen) {
            !loginOverlay && showScroll();
        }
        else {
            setInnerSearchValue('');
        }
    }, [isSearchOpen]);
    useEffect(function () {
        console.log('searchValue', searchValue);
    }, [searchValue]);
    useEffect(function () {
        if (searchValue === '' || searchValue == undefined) {
            return;
        }
        setInnerSearchValue(searchValue);
        fetchSearch(searchValue);
    }, [debouncedValue]);
    useEffect(function () {
        width <= 1024 && setIsFocusOnSearchInput(false);
        if (!isMenuOpen) {
            setInnerSearchValue('');
        }
    }, [isMenuOpen]);
    useEffect(function () {
        if (searchValue === '') {
            setInnerSearchValue('');
        }
    }, [searchValue]);
    var goToSearchPage = function () {
        selectSearchItem(searchValue);
        if (history.location.pathname !== '/search') {
            history.push('/search');
        }
        else {
            setIsSearchOpen(false);
            setIsMenuOpen(false);
            showScroll();
        }
    };
    var closeMenus = function () {
        setIsSearchOpen(false);
        setIsMenuOpen(false);
    };
    if (!isMenuOpen && !isSearchOpen) {
        return null;
    }
    var onEnterBlocked = function () {
        setIsEnterBlocked(true);
    };
    var searchItem = searchValue.length != 0 ? searchArray : [];
    return (_jsxs("div", { "aria-label": 'mobile inner menu', className: "inner-menu show-on-mobile ".concat(!isMenuOpen && 'convert-mobile-menu-to-search'), children: [_jsx("div", { className: 'beta-bug-show-on-mobile', children: _jsx("div", { className: 'beta-bug', children: "BETA" }) }), (!isMenuOpen || width <= 1024) && _jsx(SearchBar, { searchValue: innerSearchValue, setSearchValue: setSearchValue, setIsSearchOpen: setIsSearchOpen, IsEnterBlocked: IsEnterBlocked, goToSearchPage: goToSearchPage, setIsFocusOnSearchInput: function (isFocus) { return setIsFocusOnSearchInput(isFocus); } }), isFocusOnSearchInput && innerSearchValue == '' &&
                _jsx(RecentSearches, { setSearchValue: setSearchValue, isSearchOpen: isSearchOpen, width: width }), innerSearchValue === '' ? (width <= 1024 && !isFocusOnSearchInput &&
                _jsx(InnerMenu, {})) : ((!isMenuOpen || width <= 1024) &&
                _jsx(SearchResults, { items: searchItem, searchValue: searchValue, onEnterBlocked: onEnterBlocked, goToSearchPage: goToSearchPage, closeMenus: closeMenus }))] }));
}
var CompleteMenu = function (_a) {
    var _b;
    var setIsMenuOpen = _a.setIsMenuOpen;
    var _c = __read(useAtom(LoginOverlayVisible), 2), setLoginOverlay = _c[1];
    var _d = __read(useAtom(LogoutAtom), 2), logout = _d[1];
    var _e = __read(useAtom(AccountInfoAtom), 1), accountInfo = _e[0];
    var _f = __read(useAtom(LoginStatusAtom), 1), loginStatus = _f[0];
    var _g = __read(useState(false), 2), sendActive = _g[0], setSendActive = _g[1];
    var _h = useCounter('verification_time'), startTimer = _h.startTimer, sentTime = _h.sentTime, status = _h.status;
    var history = useHistory();
    var onMenuItemClicked = function () {
        setIsMenuOpen(false);
        showScroll();
    };
    var onLogOutClicked = function () {
        logout();
        onMenuItemClicked();
    };
    var onEmailResendClicked = function () {
        setSendActive(false);
        if (typeof status === 'boolean') {
            ResendVerification().then(function () {
                startTimer();
            }).catch(function (e) {
                console.log(e);
                setSendActive(true);
            });
        }
    };
    useEffect(function () {
        status === false && setSendActive(true);
    }, [status]);
    return _jsx("div", { className: "complete-menu-container ".concat(loginStatus !== "LoggedIn" && 'complete-menu-accounts-user-not-loggedIn'), children: _jsx("div", { className: 'complete-menu-accounts', children: loginStatus !== "LoggedIn" ?
                _jsxs(React.Fragment, { children: [_jsx("div", { onClick: function () { return setLoginOverlay(true); }, className: 'complete-menu-accounts-nav', children: _jsx("span", { children: "Log In" }) }), _jsx(Link, { onClick: onMenuItemClicked, to: '/library', className: 'complete-menu-accounts-nav-link', children: _jsx("span", { children: "Library" }) })] })
                :
                    _jsxs(React.Fragment, { children: [_jsx("div", { className: 'complete-new-menu-greeting', children: accountInfo.email }), accountInfo.verified === false && _jsxs("div", { className: 'account-verify-message-inner-wrapper', children: [_jsx("span", { className: 'account-verify-message-text', children: "Your account has not been verified." }), _jsx(KodanshaArrow, { onClick: onEmailResendClicked, active: sendActive, text: typeof status !== 'boolean' ? 'EMAIL HAS BEEN SENT' : 'SEND VERIFICATION EMAIL', withArrow: false })] }), _jsx("div", { className: 'complete-menu-accounts-nav', children: _jsx(Link, { onClick: onMenuItemClicked, to: '/account', className: 'complete-menu-accounts-nav-link', children: _jsx("span", { children: "Account" }) }) }), loginStatus !== "LoggedIn" && _jsx(Link, { onClick: onMenuItemClicked, to: '/library', className: 'complete-menu-accounts-nav-link', children: _jsx("span", { children: "Library" }) }), ((_b = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.roles) === null || _b === void 0 ? void 0 : _b.includes('admin')) && _jsx(Link, { onClick: onMenuItemClicked, to: '/dashboard', className: 'complete-menu-accounts-nav-link complete-menu-accounts-nav-dashboard', children: _jsx("span", { children: "Dashboard" }) }), _jsx("div", { onClick: onLogOutClicked, className: 'complete-menu-accounts-nav-link complete-menu-accounts-nav-link-logout', children: _jsx("span", { children: "Log Out" }) })] }) }) });
};
export function KodanshaNavbar() {
    var width = useWindowSize().width;
    var _a = __read(useState(false), 2), isMenuOpen = _a[0], setIsMenuOpen = _a[1];
    var _b = __read(useAtom(FetchCartAtom), 1), cartAnyType = _b[0];
    //const [searchValue, setSearchValue] = useState('');
    var _c = __read(useState(false), 2), isSearchOpen = _c[0], setIsSearchOpen = _c[1];
    var _d = __read(useAtom(ShowCartAtom), 2), showCart = _d[0], setShowCart = _d[1];
    var _e = __read(useAtom(LoginOverlayVisible), 2), loginOverLay = _e[0], setLoginOverlay = _e[1];
    var _f = __read(useState(false), 2), isFocusOnSearchInput = _f[0], setIsFocusOnSearchInput = _f[1];
    var _g = __read(useAtom(LoginStatusAtom), 1), loginStatus = _g[0];
    var _h = __read(useAtom(AccountInfoAtom), 1), accountInfo = _h[0];
    useEffect(function () {
        if (isMenuOpen) {
            hideScroll();
        }
        if (isMenuOpen || showCart) {
            setIsSearchOpen(false);
            // console.log('scrollableWrapper.current.style.overflowY', getComputedStyle(scrollableWrapper.current).overflowY);
            // console.log('navbar', getComputedStyle(navbar.current).height);
            // console.log('cart', getComputedStyle(cart.current).height);
            // setTimeout(() => {
            //     console.log('scrollableWrapper.current.style.overflowY', getComputedStyle(scrollableWrapper.current).overflowY);
            // }, 1000);
        }
        else {
            // showScroll();
            // console.log('scroll_c', 'nav 1');
        }
    }, [isMenuOpen, showCart]);
    useEffect(function () {
        return function () {
            // showScroll();
            // console.log('scroll_c', 'nav 2');
        };
    }, []);
    useEffect(function () {
        if (loginOverLay) {
            setIsMenuOpen(false);
        }
    }, [loginOverLay]);
    function CartButton() {
        var _a, _b;
        function LoginOrMenuButton() {
            if (loginStatus === "LoggedIn" || width <= 1024) {
                return (_jsx("a", { href: '#', style: { backgroundColor: isMenuOpen && '#000000', color: isMenuOpen && '#ffffff' }, className: 'button', children: "Menu" }));
            }
            if (loginStatus === "LoggedOut") {
                return (_jsx("a", { href: '#', style: { backgroundColor: isMenuOpen && '#000000', color: isMenuOpen && '#ffffff' }, className: "button login-when-logged-out-large-screens", children: "Login" }));
            }
            return (_jsx("a", { className: "button disabled", children: " ... " }));
        }
        return (_jsxs("div", { className: 'div-instead-of-ul-desktop', children: [_jsxs("div", { className: 'list-menu-and-cart', children: [_jsx("a", { href: '#', style: { backgroundColor: showCart && '#000000', color: showCart && '#ffffff' }, onClick: function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                showCart && showScroll();
                                setShowCart(function (showCart) { return !showCart; });
                                setIsMenuOpen(false);
                            }, "aria-expanded": showCart, "aria-controls": 'kodansha-cart-popup', "aria-label": 'Open Cart', className: 'button', children: "Cart" }), _jsx("span", { "aria-label": 'Items in cart', className: 'card-quantity-number', children: (_b = (_a = cartAnyType === null || cartAnyType === void 0 ? void 0 : cartAnyType.cartItems) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : '0' })] }), _jsxs("div", { className: 'list-menu-and-cart', onClick: function (e) {
                        e.preventDefault();
                        if (loginStatus === "LoggedIn" || width <= 1024) {
                            isMenuOpen && showScroll();
                            setIsMenuOpen(function (isMenuOpen) { return !isMenuOpen; });
                        }
                        else if (loginStatus === "LoggedOut") {
                            setLoginOverlay(true);
                        }
                        setShowCart(false);
                        setIsFocusOnSearchInput(false);
                    }, children: [accountInfo.verified === false && loginStatus === "LoggedIn" &&
                            _jsx("span", { "aria-label": 'account is not verified', className: 'menu-not-verified', children: "!" }), _jsx(LoginOrMenuButton, {})] })] }));
    }
    var closeCarts = function () {
        showScroll();
        setShowCart(false);
    };
    var goToBrowse = function () {
        closeCarts();
        clearBrowseData();
    };
    var onSearchClicked = function (e) {
        e.preventDefault();
        setIsSearchOpen(function (isSearchOpen) { return !isSearchOpen; });
        closeCarts();
        setIsMenuOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("nav", { onClick: function (e) {
                    e.stopPropagation();
                    if (e.currentTarget === e.target) {
                        showScroll();
                        setShowCart(false);
                        setIsMenuOpen(false);
                    }
                }, className: 'KodanshaNavbar', style: { width: "calc(100vw - ".concat(getScrollbarWidth(), "px)") }, children: [_jsxs("div", { className: 'inner-navbar', children: [_jsxs(Link, { to: '/', "aria-label": 'Kodansha Logo', children: [_jsx(FullLogo, { "aria-label": 'logo', className: 'logo logo-more-420' }), _jsx(SmallLogo, { "aria-label": 'logo', className: 'logo logo-less-420' })] }), _jsx("div", { className: 'beta-bug', children: "BETA" }), _jsx("nav", { "aria-label": 'navigation bar', className: 'hide-on-mobile', children: _jsxs("div", { className: 'div-instead-of-ul-desktop', children: [_jsx(Link, { onClick: goToBrowse, "aria-label": 'link to browse page', className: 'route', to: '/browse', children: "Browse" }), _jsx(Link, { onClick: closeCarts, "aria-label": 'link to news page', className: 'route', to: '/news', children: "News" }), _jsx(Link, { onClick: closeCarts, "aria-label": 'link to library page', className: 'route', to: '/library', children: "Library" }), _jsx(Link, { onClick: function (e) {
                                                onSearchClicked(e);
                                                setIsFocusOnSearchInput(true);
                                                hideScroll();
                                            }, className: 'route', to: '', children: "Search" }), CartButton()] }) }), _jsx("nav", { "aria-label": 'cart section', className: 'show-on-mobile', children: _jsx(React.Fragment, { children: CartButton() }) })] }), _jsx(ShowInnerMenu, { isMenuOpen: isMenuOpen, isSearchOpen: isSearchOpen, setIsMenuOpen: setIsMenuOpen, setIsFocusOnSearchInput: setIsFocusOnSearchInput, isFocusOnSearchInput: isFocusOnSearchInput, setIsSearchOpen: setIsSearchOpen }), isMenuOpen && _jsx(CompleteMenu, { setIsMenuOpen: setIsMenuOpen }), _jsx("div", { id: 'kodansha-cart-popup', className: 'dropdown ' + (showCart ? '' : 'hidden'), children: _jsx(KodanshaCart, { CloseCarts: closeCarts }) })] }), (showCart || isMenuOpen) && _jsx("div", { onClick: function () {
                    setIsMenuOpen(false);
                    setShowCart(false);
                    showScroll();
                }, className: 'navbar-backdrop' })] }));
}
;
